import { computed } from "vue";
import { workerStore } from "@/store/worker";

/**
 * Способ отправки сообщения из профиля сотрудника (поле MessageSendingWay):
 *   0 — Enter переносит строку, Ctrl+Enter отправляет;
 *   1 — Enter отправляет, Shift+Enter переносит строку (Ctrl+Enter тоже отправляет).
 *
 * Пока профиль не загружен — 0.
 */
export function useMessageSendingWay() {
	const wStore = workerStore();

	const isEnterSending = computed(() => wStore.workerProfile?.MessageSendingWay === 1);

	const newLineMode = computed<"enter" | "shift-enter">(() =>
		isEnterSending.value ? "shift-enter" : "enter"
	);
	const sendHintKey = computed(() =>
		isEnterSending.value ? "chat_send_hint_enter" : "chat_send_hint_ctrl_enter"
	);

	return { newLineMode, sendHintKey };
}
